import React from 'react';

function Footer() {
    return (
        <div className='footer'>
            <p>&copy; 2019 CYNY CAD VR</p>
        </div>
    )
}

export default Footer;